<template>
  <div v-if="tapRequestId && loaded" class="row">
    <slot name="Observations" />
    <div v-if="model.analyzerCSEE.cseeDirectorConsult" class="col-12">
      <TextAreaSection
        :title="'Justificación de Referir Consulta al Director del CSEE'"
        :label="'Justificar referido al Director del CSEE:'"
        :value="model.analyzerCSEE.cseeDirectorConsult"
        :readonly="true"
      />
    </div>

    <div class="col-12">
      <FacilitatorInquiries
        :submitted-date="model.submittedDate"
        :show-attendee-user="false"
        :can-delete="canDeleteFacilitatorInquiries"
        :is-read-only="
          readonly || sectionsStates[enums.sections['Consultas']].readonly
        "
        :value="model.inquiries"
        title="Consultas"
      />
    </div>

    <div class="col-12 pt-3">
      <SectionTitle
        :has-line="true"
        content="Del proceso de análisis, se recomienda:"
      />
    </div>

    <div class="col-12">
      <CollapsibleItem
        :disabled="
          readonly ||
            sectionsStates[enums.sections['Recomendar Reunion COMPU']].readonly
        "
        :active.sync="collapseTogglers.compuRecommendations"
        activator-text="Se recomienda que se reúna el COMPU para"
        @update:active="deleteCOMPURecommendation($event)"
      >
        <div class="bg-light-gray p-3">
          <ValidationProvider
            name="Recomendaciones COMPU"
            v-slot="{ errors, validate: _validate }"
            :rules="{ required: validate }"
            :custom-messages="{
              required:
                'Favor seleccionar al menos una opción que recomiende que el COMPU se reúna.',
            }"
          >
            <input
              type="hidden"
              :required="true"
              :value="model.compuRecommendations.length > 0 ? '1' : ''"
            />
            <ORERecommendations
              :disabled="
                readonly ||
                  sectionsStates[enums.sections['Recomendar Reunion COMPU']]
                    .readonly
              "
              :questionnaire="catalogs.oreRecommendations.questionnaire"
              :answers.sync="model.compuRecommendations"
              :subject="
                tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisCSEE
              "
              :validate="validate"
              @input="runValidation(_validate)"
            />
            <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
          </ValidationProvider>
        </div>
      </CollapsibleItem>
    </div>

    <div class="col-12">
      <CollapsibleItem
        :disabled="
          readonly ||
            sectionsStates[
              enums.sections['Búsqueda Localizaciones Disponibles']
            ].readonly ||
            sectionsStates[
              enums.sections['Búsqueda Localizaciones Disponibles Otra Region']
            ].readonly ||
            sectionsStates[enums.sections['Crear Alternativa Ubicación']]
              .readonly
        "
        :active.sync="collapseTogglers.schoolRecommendations"
        activator-text="Se realiza una segunda búsqueda de localizaciones disponibles"
        @update:active="deleteSchoolRecommendation($event)"
      >
        <div class="bg-light-gray p-3">
          <AvailableLocations
            :readonly="
              readonly ||
                sectionsStates[
                  enums.sections['Búsqueda Localizaciones Disponibles']
                ].readonly
            "
            :academic-year-id="model.academicYearId"
            :region="model.region"
            :municipality="model.municipality"
            :items.sync="model.recomendations"
            :tap-request-type-id="tapRequestTypeId"
            :validate-options="
              !readonly &&
                !sectionsStates[
                  enums.sections['Búsqueda Localizaciones Disponibles']
                ].readonly &&
                validate
            "
            :validate-items="
              !readonly &&
                !sectionsStates[
                  enums.sections['Búsqueda Localizaciones Disponibles']
                ].readonly &&
                validate
            "
            :has-items-without-availability="isConfiguredAnalyzerCSEE"
            enable-location-not-available-option
          >
            <template #location-not-available>
              <div class="bg-white rounded">
                <div class="row px-3 pb-3 pl-lg-3 pr-lg-3">
                  <div class="col-12 pt-3">
                    <SectionTitle
                      :has-line="true"
                      content="El Plan de acción de la ORE para atender la necesidad es:"
                    />
                  </div>

                  <div class="col-12">
                    <OrderedHeader order="1">
                      <div class="row align-items-stretch">
                        <div class="col">
                          <div class="h-100 d-flex align-items-center">
                            Consultar con otro director de CSEE de las ORE
                            aledañas para identificar la alternativa de
                            ubicación recomendada.
                          </div>
                        </div>
                        <div class="col-12 col-md-5 col-lg-4 col-xl-3">
                          <div
                            class="h-100 d-flex align-items-end justify-content-end"
                          >
                            <div class="text-nowrap nowrap-radio">
                              <ValidationProvider
                                name="Consultar otro director CSEE (Corto/Largo plazo)"
                                v-slot="{ errors }"
                                :disabled="
                                  readonly ||
                                    sectionsStates[
                                      enums.sections[
                                        'Búsqueda Localizaciones Disponibles Otra Region'
                                      ]
                                    ].readonly ||
                                    !validate
                                "
                                :rules="{
                                  required: validate,
                                  is_not: 0,
                                }"
                                :custom-messages="{
                                  required: 'Favor de marcar una opción.',
                                  is_not: 'Favor de marcar una opción.',
                                }"
                              >
                                <CustomRadio
                                  :disabled="
                                    readonly ||
                                      sectionsStates[
                                        enums.sections[
                                          'Búsqueda Localizaciones Disponibles Otra Region'
                                        ]
                                      ].readonly
                                  "
                                  is-question-list
                                  :error="!!errors[0]"
                                  :custom-error-msg="errors[0] || ''"
                                  :options="firstOptionsWithState"
                                  :change-event="
                                    (item) => {
                                      model.analyzerCSEE.requestAnotherDirector =
                                        item.id;
                                    }
                                  "
                                />
                                <input
                                  v-model="
                                    model.analyzerCSEE.requestAnotherDirector
                                  "
                                  type="hidden"
                                  :required="validate"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </OrderedHeader>

                    <div class="bg-light-gray p-3">
                      <AvailableLocationsOtherRegion
                        :readonly="
                          readonly ||
                            sectionsStates[
                              enums.sections[
                                'Búsqueda Localizaciones Disponibles Otra Region'
                              ]
                            ].readonly
                        "
                        :academic-year-id="model.academicYearId"
                        :region="model.region"
                        :tap-request-type-id="tapRequestTypeId"
                        :items.sync="model.recomendations"
                        :alternative-identified.sync="
                          model.analyzerCSEE.isAlternativeIdentificated
                        "
                        :validate-options="
                          !readonly &&
                            !sectionsStates[
                              enums.sections[
                                'Búsqueda Localizaciones Disponibles Otra Region'
                              ]
                            ].readonly &&
                            validate
                        "
                        :validate-items="
                          !readonly &&
                            !sectionsStates[
                              enums.sections[
                                'Búsqueda Localizaciones Disponibles Otra Region'
                              ]
                            ].readonly &&
                            validate
                        "
                      />
                    </div>
                  </div>

                  <div class="col-12 pt-3">
                    <OrderedHeader order="2">
                      <div class="row align-items-stretch">
                        <div class="col">
                          <div class="h-100 d-flex align-items-center">
                            Referir a la Secretaría Asociada de Educación
                            Especial para consulta. El que una ORE determine
                            realizar esta consulta NO constituye un compromiso a
                            que se comprará o reembolsará el servicio educativo
                            en una escuela privada a costo público.
                          </div>
                        </div>
                        <div class="col-12 col-md-5 col-lg-4 col-xl-3">
                          <div
                            class="h-100 d-flex align-items-end justify-content-end"
                          >
                            <div class="text-nowrap nowrap-radio">
                              <ValidationProvider
                                name="Referir a Secretaría Asociada de Educación Especial"
                                v-slot="{ errors }"
                                :disabled="
                                  readonly ||
                                    sectionsStates[
                                      enums.sections[
                                        'Referir a la Secretaría Asociada de Educación Especial'
                                      ]
                                    ].readonly ||
                                    !validate
                                "
                                :rules="{ required: validate, is_not: 0 }"
                                :custom-messages="{
                                  required: 'Favor de marcar una opción.',
                                  is_not: 'Favor de marcar una opción.',
                                }"
                              >
                                <CustomRadio
                                  :disabled="
                                    readonly ||
                                      sectionsStates[
                                        enums.sections[
                                          'Referir a la Secretaría Asociada de Educación Especial'
                                        ]
                                      ].readonly
                                  "
                                  is-question-list
                                  :error="!!errors[0]"
                                  :custom-error-msg="errors[0] || ''"
                                  container-class="bg-white"
                                  :options="thirdOptionsWithState"
                                  :change-event="
                                    (item) => {
                                      model.analyzerCSEE.refferToAssistent =
                                        item.id;
                                    }
                                  "
                                />
                                <input
                                  v-model="model.analyzerCSEE.refferToAssistent"
                                  type="hidden"
                                  :required="validate"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </OrderedHeader>
                  </div>
                </div>
              </div>
            </template>
          </AvailableLocations>
        </div>
      </CollapsibleItem>
    </div>

    <div class="col-12">
      <ValidationProvider
        name="Documento Propuesta de Servicios"
        v-slot="{ validate: _validate, errors }"
        :disabled="
          readonly ||
            sectionsStates[enums.sections['Documentos']].readonly ||
            !validate
        "
        vid="document"
        :rules="{ required: validate ? { allowFalse: false } : false }"
        :custom-messages="{
          required:
            'Es requerido anejar el documento de Propuesta de Servicios.',
        }"
      >
        <Documents
          :key="documentLength"
          :disabled="
            readonly || sectionsStates[enums.sections['Documentos']].readonly
          "
          :documents="getDocumentData"
          :document-types="document.documentTypes"
          :invalid-types="getInvalidDocumentTypes"
          :center-title-header="'Documentos'"
          @input="_validate(validateDocument)"
          @files="
            gettingDocument($event);
            _validate(document.data && !![...document.data.files].length);
          "
        />

        <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
      </ValidationProvider>
    </div>

    <div
      v-if="showServicesSummary && servicesSummary.length > 0"
      class="col-12"
    >
      <ServicesSummary
        :services="servicesSummary"
        :collections="servicesSummaryCollections"
        :readonly="true"
        :hide-total="false"
      />
    </div>
    <div v-else-if="showServicesSummary" class="col-12">
      <b-alert show variant="info" class="mb-0">Sin servicios</b-alert>
    </div>

    <div class="col-12">
      <Requesters
        keep-signed
        :limit-new-signatures-to="1"
        role-label="Puesto"
        :allow-add-more="false"
        :submitted="
          readonly ||
            sectionsStates[enums.sections['Funcionarios Solicitan']].readonly
        "
        :requesters="model.requesters"
        :positions-list="requestersPositionsList"
        :cannot-edit-name="true"
        :use-role="true"
        title="Firma de Director del CSEE"
        @input="runValidation(_validate)"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomRadio from 'custom-radio';
import CollapsibleItem from '../CollapsibleItem';
import AvailableLocations from '../AvailableLocations';
import AvailableLocationsOtherRegion from '../AvailableLocationsOtherRegion';
import {
  FacilitatorInquiries,
  ORERecommendations,
  Documents,
  CreateSchoolRecommendationAlternative,
  Requesters,
} from '@/components/pei/ubication-tech-assistance/_components';
import OrderedHeader from '../OrderedHeader';
import Error from 'custom-error';
import {
  getCSEEAnalysis,
  getDocumentTypesByCode,
  deleteCOMPURecommendation,
  deleteSchoolRecommendation,
  deleteDirector,
} from '@/services/api/tapRequest.api';
import store from '@/store/index';
import { getORERecommendations } from '@/components/pei/ubication-tech-assistance/_api';
import {
  tapRequestTypesEnum,
  tapRequestQuestionSectionsEnum,
} from '@/components/pei/ubication-tech-assistance/_types';
import TextAreaSection from '../TextAreaSection';
import alert from 'utils/mixins/alert.mixin';
import { UTA_MANAGEMENT_SECTION_ENUM } from '@/components/pei/ubication-tech-assistance/_config/management';
import ServicesSummary from '@/components/pei/ubication-tech-assistance/management/_components/CentralLevelAnalysis/components/ServicesSummary/Main.vue';

const TermsEnum = { ShortTerm: 1, LongTerm: 2 };

const oRePlanQuestionOptions = (check = null) => [
  {
    id: TermsEnum.ShortTerm,
    label: 'Corto Plazo',
    check: check == TermsEnum.ShortTerm,
    invalid: false,
    disabled: false,
  },
  {
    id: TermsEnum.LongTerm,
    label: 'Largo Plazo',
    check: check == TermsEnum.LongTerm,
    invalid: false,
    disabled: false,
  },
];

export default {
  name: 'CSEEAnalisys',
  inject: { studentSieId: { default: 0 }, tapRequestId: { default: 0 } },
  components: {
    SectionTitle,
    CollapsibleItem,
    ORERecommendations,
    AvailableLocations,
    AvailableLocationsOtherRegion,
    CreateSchoolRecommendationAlternative,
    OrderedHeader,
    CustomRadio,
    FacilitatorInquiries,
    Documents,
    Requesters,
    TextAreaSection,
    Error,
    ServicesSummary,
  },
  props: {
    readonly: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
    modelToSave: { type: Object, default: () => {} },
    sectionsStates: { type: Object, default: () => ({}) },
    showServicesSummary: { type: Boolean, default: false },
    servicesSummary: { type: Array, default: () => [] },
    servicesSummaryCollections: { type: Object, default: () => ({}) },
  },
  data: () => ({
    documentLength: 0,
    enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
    loaded: false,
    collapseTogglers: {
      schoolRecommendations: false,
      compuRecommendations: false,
    },
    document: {
      documentTypes: [],
      // Variables to save component data.
      data: {
        files: [],
        types: [],
      },
    },
    tapRequestTypeId: tapRequestTypesEnum.DirectorAnalysis,
    model: {
      academicYearId: null,
      region: null,
      municipality: null,
      status: null,
      studentSieId: null,
      submittedDate: null,
      schoolRecommendations: [],
      compuRecommendations: [],
      inquiries: [],
      analyzerCSEE: {
        requestAnotherDirector: null,
        isAlternativeIdentificated: null,
        isNewAlternativeUbication: null,
        hasLounge: null,
        hasHumanResourceAttendant: null,
        hasEquipmentAndMaterials: null,
        refferToAssistent: null,
      },
      documents: [],
      requesters: [],
    },
    oREPlanQuestions: {
      first: oRePlanQuestionOptions(),
      second: oRePlanQuestionOptions(),
      third: oRePlanQuestionOptions(),
    },
    catalogs: {
      oreRecommendations: {
        questionnaire: {},
      },
    },
    tapRequestQuestionSectionsEnum,
    requestersPositionsList: [],
  }),
  computed: {
    firstOptionsWithState() {
      return this.oREPlanQuestions.first.map((x) => ({
        ...x,
        check: this.model.analyzerCSEE.requestAnotherDirector == x.id,
      }));
    },
    secondOptionsWithState() {
      return this.oREPlanQuestions.second.map((x) => ({
        ...x,
        check: this.model.analyzerCSEE.isNewAlternativeUbication == x.id,
      }));
    },
    thirdOptionsWithState() {
      return this.oREPlanQuestions.third.map((x) => ({
        ...x,
        check: this.model.analyzerCSEE.refferToAssistent == x.id,
      }));
    },
    canDeleteFacilitatorInquiries() {
      return store.getters.HasPermission('facilitator.inquiries.delete');
    },
    alternativeCreationModelProxy: {
      get() {
        const {
          hasLounge,
          hasHumanResourceAttendant,
          hasEquipmentAndMaterials,
          locationSchool,
          region,
          municipality,
        } = this.model.analyzerCSEE;
        return {
          hasLounge,
          hasHumanResourceAttendant,
          hasEquipmentAndMaterials,
          locationSchool,
          region,
          municipality,
        };
      },
      set({
        hasLounge,
        hasHumanResourceAttendant,
        hasEquipmentAndMaterials,
        locationSchool,
        region,
        municipality,
      }) {
        this.model.analyzerCSEE.hasLounge = hasLounge;
        this.model.analyzerCSEE.hasHumanResourceAttendant = hasHumanResourceAttendant;
        this.model.analyzerCSEE.hasEquipmentAndMaterials = hasEquipmentAndMaterials;
        this.model.analyzerCSEE.locationSchool = locationSchool;
        this.model.analyzerCSEE.region = region;
        this.model.analyzerCSEE.municipality = municipality;
      },
    },
    getDocumentData() {
      return this.document.data;
    },
    validateDocument() {
      const documentTypeEnum = {
        propuestaServiciosAnterior: 191,
        propuestaServicios: 196,
      };

      return (
        (document.data && !![...document.data.files].length) ||
        this.document.data.types.filter(
          (x) =>
            x === documentTypeEnum.propuestaServiciosAnterior ||
            x === documentTypeEnum.propuestaServicios
        ).length > 0
      );
    },
    getInvalidDocumentTypes() {
      const documentTypeEnum = {
        propuestaServicios: 196,
      };
      const invalidTypes = [];

      if (
        this.document.data.types.filter(
          (x) => x === documentTypeEnum.propuestaServicios
        ).length > 0
      ) {
        invalidTypes.push(documentTypeEnum.propuestaServicios);
      }

      return invalidTypes;
    },
    isConfiguredAnalyzerCSEE() {
      return (
        this.model.recomendations.length > 0 ||
        this.model.schoolRecommendations.length > 0 ||
        (this.model.analyzerCSEE.id > 0 &&
          (this.model.analyzerCSEE.hasLounge > 0 ||
            this.model.analyzerCSEE.hasHumanResourceAttendant > 0 ||
            this.model.analyzerCSEE.hasEquipmentAndMaterials > 0 ||
            !!this.model.analyzerCSEE.locationSchool ||
            !!this.model.analyzerCSEE.region ||
            !!this.model.analyzerCSEE.municipality ||
            this.model.analyzerCSEE.isAlternativeIdentificated !== null ||
            this.model.analyzerCSEE.isNewAlternativeUbication > 0 ||
            !!this.model.analyzerCSEE.RequestAnotherDirector ||
            !!this.model.analyzerCSEE.RefferToAssistent))
      );
    },
    isModelToSaveConfiguredAnalyzerCSEE() {
      return (
        this.modelToSave.recomendations.length > 0 ||
        this.modelToSave.schoolRecommendations.length > 0 ||
        this.modelToSave.analyzerCSEE.id > 0 ||
        this.modelToSave.analyzerCSEE.hasLounge > 0 ||
        this.modelToSave.analyzerCSEE.hasHumanResourceAttendant > 0 ||
        this.modelToSave.analyzerCSEE.hasEquipmentAndMaterials > 0 ||
        !!this.modelToSave.analyzerCSEE.locationSchool ||
        !!this.modelToSave.analyzerCSEE.region ||
        !!this.modelToSave.analyzerCSEE.municipality ||
        !!this.modelToSave.analyzerCSEE.isAlternativeIdentificated ||
        this.modelToSave.analyzerCSEE.isNewAlternativeUbication > 0 ||
        !!this.modelToSave.analyzerCSEE.RequestAnotherDirector ||
        !!this.modelToSave.analyzerCSEE.RefferToAssistent
      );
    },
  },
  methods: {
    runValidation(validateFn) {
      if (validateFn && typeof validateFn === 'function') {
        validateFn();
      }
    },
    async getData() {
      const { data } = await getCSEEAnalysis(this.tapRequestId);
      this.model = {
        ...this.model,
        ...data,
        document: this.document,
        inquiries: data.inquiries || [],
        analyzerCSEE: data.analyzerCSEE || {},
        compuRecommendations: data.compuRecommendations || [],
        requesters: data.staffMembers.map((c) => {
          return {
            id: c.id,
            status: c.status,
            userName: c.userName,
            name: c.fullName,
            email: c.email,
            phone: c.telephoneNumber,
            signed: c.signed,
            role: {
              id: c.rolId,
              name: c.rol,
            },
            signDate: c.signDate,
          };
        }),
      };
      this.$emit('update:modelToSave', this.model);
      this.fillDocuments();
    },
    async getCatalogs() {
      const data = await getORERecommendations(
        tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisCSEE
      );
      this.catalogs.oreRecommendations.questionnaire = data;
    },
    initTogglers() {
      this.collapseTogglers.schoolRecommendations = this.isConfiguredAnalyzerCSEE;
      this.collapseTogglers.compuRecommendations = !!this.model
        .compuRecommendations.length;
    },
    async getDocumentTypesByCode(code) {
      const { data } = await getDocumentTypesByCode(code);
      data.forEach((element) => {
        this.document.documentTypes.push({
          id: element.id,
          name: element.name,
        });
      });
    },
    async gettingDocument(data) {
      this.document.data = data;
    },
    fillDocuments() {
      this.document.data = {
        files: [],
        types: [],
      };
      if (this.model.documents && this.model.documents.length > 0) {
        this.model.documents.forEach((element) => {
          this.document.data.files.push({
            name: element.filename,
            peiStatus: element.peiStatus,
            pei: element.peiId,
            documentType: element.document.documentTypeId,
            documentTypeName: element.document.documentTypeName,
            id: element.documentId,
            inServer: true,
            isReport: element.isReport,
            readOnly: element.readOnly,
            createdDate: element.createdDate,
            userName: element.userName,
            userFullName: element.userFullName,
            isAmendmentDocument: element.isAmendmentDocument,
          });
          this.document.data.types.push(element.document.documentTypeId);
        });
      }
      this.documentLength++;
    },
    async deleteCOMPURecommendation(value) {
      if (!value && this.model.compuRecommendations.length > 0) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para recomendar que el COMPU se reúna?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteCOMPURecommendation(
            this.model.id,
            tapRequestQuestionSectionsEnum.RecomendarCOMPUParaAnalisisCSEE
          )
            .then(() => {
              this.model.compuRecommendations = [];
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando Recomendaciones de COMPU',
                'error',
                () => (this.collapseTogglers.compuRecommendations = true)
              );
            });
        } else {
          this.collapseTogglers.compuRecommendations = true;
        }
      }
    },
    async deleteSchoolRecommendation(value) {
      if (
        !value &&
        (this.isConfiguredAnalyzerCSEE ||
          this.isModelToSaveConfiguredAnalyzerCSEE)
      ) {
        const deleteResponse = await alert.methods.ShowCancelModal(
          'Confirmación',
          'Usted cuenta con información registrada. ¿Está seguro que desea eliminar la información para el proceso de búsqueda de localizaciones disponibles?',
          'Sí',
          'No'
        );

        if (deleteResponse) {
          deleteDirector(this.model.id)
            .then(() => {
              this.model.analyzerCSEE = {};
              deleteSchoolRecommendation(this.model.id)
                .then(() => {
                  this.model.schoolRecommendations = [];
                  this.model.recomendations = [];
                })
                .catch(() => {
                  alert.methods.ShowToast(
                    'Alerta',
                    'Error borrando Recomendaciones de Escuela',
                    'error',
                    () => (this.collapseTogglers.schoolRecommendations = true)
                  );
                });
            })
            .catch(() => {
              alert.methods.ShowToast(
                'Alerta',
                'Error borrando Recomendaciones de Escuela',
                'error',
                () => (this.collapseTogglers.schoolRecommendations = true)
              );
            });
        } else {
          this.model.analyzerCSEE.id = this.model.id;
          this.collapseTogglers.schoolRecommendations = true;
        }
      }
    },
  },
  async created() {
    await Promise.all([
      this.getCatalogs(),
      this.getData(),
      this.getDocumentTypesByCode('TapRequestDirector'),
    ]);
    this.initTogglers();
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
::v-deep textarea:disabled {
  background-color: #f2f2f2 !important;
}
::v-deep .nowrap-radio .custom-radio-container > div {
  border-top: 1px solid lightgray;
  border-right: 1px solid lightgray;
  &:first-child {
    border-left: 1px solid lightgray;
    border-top-left-radius: 5px;
  }
  &:last-child {
    border-top-right-radius: 5px;
  }
  background-color: white !important;
  .custom-radio-button {
    width: 100px;
    margin-right: 0;
    border-radius: 0 !important;
    &.bg-gray {
      background-color: transparent !important;
    }
  }
}

::v-deep .fas.fa-long-arrow-right.text-green {
  padding-left: 5px !important;
}

::v-deep div.square-order span.text-white.h3.m-0 {
  padding-left: 20px !important;
}
</style>
